import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { isEmergencyEnabled } from './enabled-services';

@Injectable({ providedIn: 'root' })
export class EmergencyGuard implements CanActivate {
    constructor(private router: Router) {}

    // Apartment without 'emergency' in enabledServices → the contact-admin (no-access) page
    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (isEmergencyEnabled()) {
            return true;
        }
        const service = route.data?.['service'] || 'Emergency';
        this.router.navigate(['/no-access'], { queryParams: { service } });
        return false;
    }
}
